import { cn } from "@app/lib/utils";
import { projectTabs } from "@modules/investor-relations/data";
import { trans } from "@mongez/localization";

type ProjectTabsProps = {
  activeTab: string;
  onChange: (tabKey: string) => void;
};

export function ProjectTabs({ activeTab, onChange }: ProjectTabsProps) {
  return (
    <div
      role="group"
      aria-label={trans("projectHighlights.filterLabel")}
      className="no-scrollbar -mx-1 flex max-w-full items-center gap-2 overflow-x-auto px-1 py-1"
    >
      {projectTabs.map(({ key, label }) => {
        const isActive = key === activeTab;

        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            aria-pressed={isActive}
            className={cn(
              "shrink-0 rounded-md px-4 py-1.5 text-xs font-semibold transition-colors sm:text-sm",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary",
              isActive
                ? "bg-secondary text-white"
                : "text-marine/65 hover:bg-secondary/10 hover:text-secondary",
            )}
          >
            {trans(label)}
          </button>
        );
      })}
    </div>
  );
}
